'use client'

import { ComponentPropsWithoutRef, ReactNode, forwardRef } from 'react'

import { cn } from '@/lib/utils'

type ScrollAreaProps = ComponentPropsWithoutRef<'div'> & {
  viewportClassName?: string
  children: ReactNode
}

const ScrollArea = forwardRef<HTMLDivElement, ScrollAreaProps>(
  ({ className, viewportClassName, children, ...props }, ref) => (
    <div ref={ref} className={cn('relative overflow-hidden', className)} {...props}>
      <div className={cn('h-full w-full overflow-auto rounded-[inherit]', viewportClassName)}>
        {children}
      </div>
    </div>
  )
)
ScrollArea.displayName = 'ScrollArea'

export { ScrollArea }
